<template>
  <pt-poster-review class="pt-poster-review__withData"></pt-poster-review>
</template>

<script>
import PtPosterReview from './index'
export default {
  name: 'pt-poster-review__withData',
  components: {
    'pt-poster-review': PtPosterReview
  }
}
</script>
